import React from "react"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  CloseIcon,
  Progress
} from "@carrotfertility/carotene-core"
import { FormattedMessage, useIntl } from "react-intl"

interface PartnerAccessRemovalDialogProps {
  open: boolean
  onClose: () => void
  onConfirmRemove: () => void
  isLoading?: boolean
}

export default function PartnerAccessRemovalDialog({
  open,
  onClose,
  onConfirmRemove,
  isLoading = false
}: PartnerAccessRemovalDialogProps): JSX.Element {
  const intl = useIntl()

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="remove-partner-access-dialog-title" maxWidth="md" fullWidth>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end"
        }}
      >
        <IconButton aria-label={intl.formatMessage({ defaultMessage: "Close" })} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogTitle id="remove-partner-access-dialog-title">
        <FormattedMessage defaultMessage="Are you sure you want to revoke partner access?" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage defaultMessage="This won't remove their information, but they'll no longer be able to sign in to your account." />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="secondary" disabled={isLoading}>
          <FormattedMessage defaultMessage="Close" />
        </Button>
        <Button
          onClick={onConfirmRemove}
          variant="contained"
          color="primary"
          disabled={isLoading}
          startIcon={isLoading ? <Progress size={20} /> : undefined}
        >
          <FormattedMessage defaultMessage="Revoke partner access" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}
